import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedNew202601: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_new_202601",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-01-01",
  endDate: "2026-01-31",
  impressions: 6612,
  clicks: 98,
  adsSpendDollars: 421,
  budgetDollars: 14500,
  salesDollars: 1256,
  bestEstimateRoas: 2.98,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.03,
  newCustomersAcquired: 2,
  dataAvailableAtDate: "2026-02-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
